var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdwords(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#596266",
    d: "M4.78523948,3.77488965 C4.85118502,3.98858719 4.9433105,4.1982439 5.06273073,4.39976145 L7.78721156,8.99722945 L5.66219621,12.537601 C5.66516367,12.4837715 5.66666667,12.4295585 5.66666667,12.375 C5.66666667,10.7440341 4.32352092,9.421875 2.66666667,9.421875 C2.11518708,9.421875 1.59846244,9.56835353 1.15445353,9.82394295 L4.78523948,3.77488965 Z M2.66666667,15 C1.19390733,15 3.64153152e-14,13.8247475 3.64153152e-14,12.375 C3.64153152e-14,10.9252525 1.19390733,9.75 2.66666667,9.75 C4.139426,9.75 5.33333333,10.9252525 5.33333333,12.375 C5.33333333,13.8247475 4.139426,15 2.66666667,15 Z M11.0248284,13.7216177 L5.69223602,4.84979126 C4.95595867,3.62484766 5.38874398,2.05620516 6.65888907,1.34613019 C7.92903416,0.636055213 9.55556093,1.05343871 10.2918383,2.27838232 L15.6244306,11.1502087 C16.360708,12.3751523 15.9279227,13.9437948 14.6577776,14.6538698 C13.3876325,15.3639448 11.7611057,14.9465613 11.0248284,13.7216177 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdwords);
export default __webpack_public_path__ + "static/media/Adwords.2b8f0312.svg";
export { ForwardRef as ReactComponent };